import { isFunction } from 'lodash-es';
import { Controller, useFormContext } from 'react-hook-form';

import { NeuSelect, NeuSelectProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';

type FormSelectProps = Omit<NeuSelectProps, 'name'> & {
  name: string;
  onSelectCallback?: (value: string) => void;
  triggerFields?: string[];
};

export const FormSelect = ({
  name,
  label,
  required,
  onSelectCallback,
  triggerFields = [],
  ...rest
}: FormSelectProps): JSX.Element => {
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <NeuSelect
          {...rest}
          label={required ? `${label} ${REQUIRED_SYMBOL}` : label}
          required={required}
          onNeuChange={(e) => {
            field.onChange(e.value);
            if (isFunction(onSelectCallback)) onSelectCallback(e.value);
            triggerFields.forEach((fieldName) => trigger(fieldName)); // Re-validate specified fields
          }}
          invalid={errorMessage}
          error={!!errorMessage}
        />
      )}
    />
  );
};
